import { useEffect, useState } from "react";
import { Instagram, Loader2, RefreshCw, Save } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export const ReInstagramTab = () => {
  const [cfg, setCfg] = useState(null);
  const [token, setToken] = useState("");
  const [userId, setUserId] = useState("");
  const [busy, setBusy] = useState("");

  const load = () => api.get("/admin/realestate/instagram/config").then((r) => { setCfg(r.data); setUserId(r.data.user_id || ""); }).catch(() => setCfg({}));
  useEffect(() => { load(); }, []);

  const save = async () => {
    setBusy("save");
    try { const r = await api.put("/admin/realestate/instagram/config", { ...(token ? { token } : {}), user_id: userId }); setCfg(r.data); setToken(""); toast.success("Saved"); }
    catch (e) { toast.error(formatApiErrorDetail(e)); } finally { setBusy(""); }
  };

  const sync = async () => {
    setBusy("sync");
    try { const r = await api.post("/admin/realestate/instagram/sync"); if (r.data.synced) { toast.success(`Synced ${r.data.count} posts`); load(); } else toast.error(r.data.reason || "Sync failed"); }
    catch (e) { toast.error(formatApiErrorDetail(e)); } finally { setBusy(""); }
  };

  if (!cfg) return <div className="flex min-h-[40vh] items-center justify-center"><Loader2 className="h-7 w-7 animate-spin text-[#C9A24B]" /></div>;

  return (
    <div data-testid="re-instagram-tab" className="space-y-6">
      <div>
        <h2 className="font-serif text-2xl font-semibold text-[#1A1615]">Instagram</h2>
        <p className="mt-1 text-xs text-[#91837C]">Connect Docstate's Instagram business account to sync the latest posts onto the portal.</p>
      </div>

      <div className="glass rounded-2xl p-6 space-y-4">
        <div>
          <label className="text-xs font-semibold uppercase tracking-[0.15em] text-[#B38B2D]">Instagram user ID</label>
          <input data-testid="re-ig-userid" value={userId} onChange={(e) => setUserId(e.target.value)} placeholder="178414...." className="mt-2 w-full rounded-xl border border-[#E6DCD2] bg-white px-4 py-3 text-sm outline-none focus:border-[#C9A24B]" />
        </div>
        <div>
          <label className="text-xs font-semibold uppercase tracking-[0.15em] text-[#B38B2D]">Access token {cfg.has_token && <span className="ml-1 text-emerald-500">• connected</span>}</label>
          <input data-testid="re-ig-token" value={token} onChange={(e) => setToken(e.target.value)} placeholder={cfg.has_token ? "•••••••• (leave blank to keep)" : "IGQ...."} className="mt-2 w-full rounded-xl border border-[#E6DCD2] bg-white px-4 py-3 text-sm outline-none focus:border-[#C9A24B]" />
        </div>
        <div className="flex gap-2">
          <button data-testid="re-ig-save" onClick={save} disabled={busy === "save"} className="inline-flex items-center gap-2 rounded-xl bg-[#B38B2D] px-5 py-2.5 text-sm font-medium text-white hover:opacity-90 disabled:opacity-60">{busy === "save" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save</button>
          <button data-testid="re-ig-sync" onClick={sync} disabled={busy === "sync"} className="inline-flex items-center gap-2 rounded-xl border border-[#C9A24B]/40 px-5 py-2.5 text-sm text-[#6B5E57] hover:bg-[#C9A24B]/10 disabled:opacity-60">{busy === "sync" ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />} Sync now</button>
        </div>
        <p className="text-xs text-[#91837C]"><Instagram className="mr-1 inline h-3.5 w-3.5" />{cfg.count || 0} posts synced{cfg.last_sync ? ` · last ${new Date(cfg.last_sync).toLocaleString()}` : ""}</p>
      </div>
    </div>
  );
};
